export enum AccessRole {
  User = "User",
  PowerUser = "PowerUser",
  Admin = "Admin",
  Owner = "Owner",
  Guest = "Guest",
}
